import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';
export function ThemeSwitcher() {
  const {
    theme,
    toggleTheme
  } = useTheme();
  return <button onClick={toggleTheme} className="p-2 text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-dark-hover rounded-lg transition-all duration-180 focus:outline-none focus:ring-3 focus:ring-blue-100 dark:focus:ring-blue-900" aria-label={theme === 'light' ? 'Switch to dark mode' : 'Switch to light mode'} title={theme === 'light' ? 'Dark mode' : 'Light mode'} data-id="element-846">
      {theme === 'light' ? <Moon className="w-5 h-5" data-id="element-847" /> : <Sun className="w-5 h-5" data-id="element-848" />}
    </button>;
}